import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Button } from '#/modules/commonComponents/button';
import {
  PURCHASE_AMENDMENT_STATUS,
  findOpenPurchaseAmendment,
} from '#/modules/srmMgmt/purchaseOrder/helper/purchaseAmendmentStatus';

/**
 * 「異動歷史」頁籤的新增異動按鈕（物料／非庫存採購共用）。
 * 同一採購單同時最多一張在途異動：草稿導向編輯，已提交則等待審核。
 */
const PurchaseAmendmentCreateAction = ({
  orderId,
  enabled,
  amendments,
  createPath,
  editPath,
}) => {
  const openAmendment = findOpenPurchaseAmendment(amendments);

  if (enabled && orderId && openAmendment?.status === PURCHASE_AMENDMENT_STATUS.DRAFT) {
    return (
      <Button asChild size="sm" variant="outline">
        <Link to={editPath(orderId, openAmendment.id)}>編輯異動草稿</Link>
      </Button>
    );
  }

  if (openAmendment) {
    return (
      <Button type="button" size="sm" variant="outline" disabled>
        異動審核中
      </Button>
    );
  }

  if (enabled && orderId) {
    return (
      <Button asChild size="sm" variant="outline">
        <Link to={createPath(orderId)}>新增異動</Link>
      </Button>
    );
  }

  return (
    <Button type="button" size="sm" variant="outline" disabled>
      新增異動
    </Button>
  );
};

PurchaseAmendmentCreateAction.propTypes = {
  orderId: PropTypes.string,
  enabled: PropTypes.bool,
  amendments: PropTypes.arrayOf(PropTypes.object),
  createPath: PropTypes.func.isRequired,
  editPath: PropTypes.func.isRequired,
};

export default PurchaseAmendmentCreateAction;
